<template>
  <md-toolbar
    md-elevation="4"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <!-- <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>-->
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <!-- <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
              :md-open-on-focus="false"
            >
              <label v-if="$route.meta.rtlActive">بحث...</label>
              <label v-else>Search...</label>
            </md-autocomplete>
          </div>-->
          <md-list>
            <!-- <md-list-item href="/dashboard">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>-->

            <li class="md-list-item">
              <a
                class="
                  md-list-item-router md-list-item-container md-button-clean
                  dropdown
                "
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span
                        class="notification"
                        v-if="notifications.length > 0"
                      >
                        {{ notifications.length }}
                      </span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a href="/bill-management" @click="showBillDetail()"
                          >Bạn có {{ notifications.length }} đơn hàng chưa được
                          xác nhận</a
                        >
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item class="clickable">
              <i class="material-icons" @click="logout()">cancel</i>
              <p class="hidden-lg hidden-md">Logout</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import firebase from "@/services/firebase-init.js";
export default {
  props: ["notifications"],
  data() {
    return {
      phone: null,
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
  methods: {
    showBillDetail(item) {
      this.$emit("showBillDetailFromNotify", item);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logout() {
      let that = this;
      var r = confirm("Xác nhận đăng xuất khỏi hệ thống?");
      if (r == true) {
        firebase
          .auth()
          .signOut()
          .then(function () {
            that.$store.commit("RESET_LIST_PRODUCTS");
            localStorage.clear();
            that.$router.push("/");
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        //maybe show something to confirm user remaining logged-in
      }
    },
  },
};
</script>
